export const SUPPORT_EMAIL = 'hello@actionfunder.org';
export const UK_BOUNDING_BOX = [
  [49.959999905, -7.57216793459],
  [60.5350001085, 1.68153079591],
];

export const CHARITY_ADDRESS_LOOKUP_DEBOUNCE_MS = 500; // 0.5 seconds.

// Fund amount limits (should match backend settings.MAX_TOTAL_FUND_AMOUNT and settings.MAX_INDIVIDUAL_FUND_AMOUNT)
export const MAX_TOTAL_FUND_AMOUNT = 1000000; // 1 million
export const MAX_INDIVIDUAL_FUND_AMOUNT = 50000; // 50 thousand
